module.exports = __webpack_public_path__ + "static/img/58.18b1d5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/58.png
// module id = IrE2
// module chunks = 1